import React__default from "react";
import { Grid } from "../../grid/grid/grid.mjs";
function DropdownNav({ children, className }) {
  return /* @__PURE__ */ React__default.createElement(Grid, { className, gutter: "small", align: ["middle-xs"] }, children);
}
export {
  DropdownNav
};
